module.exports = __webpack_public_path__ + "static/img/leftBtn.4a83f986.svg";